import {useBatchVideoSupport} from '../../../service/company/company-hook';
import {
    BulkEditFieldNameEnum,
    BulkUpdateCompaniesFilterType,
    BulkUpdateCompaniesQueryType,
    SkippedCompanyType,
} from '../../../service/company/company-type';

import {BulkEditFieldType} from './bulk-edit-companies-type';

const NO_SKIPPED_COMPANIES: Array<SkippedCompanyType> = [];

/**
 * Companies a video uploaded in the "Photos and videos" field will not reach. Asked as soon as the field is added,
 * so the warning is ready by the time a video is uploaded, and with the very filter the save sends.
 */
export function useSkippedVideoCompanies(
    selectedFields: Array<BulkEditFieldType>,
    filter: BulkUpdateCompaniesFilterType,
    options: BulkUpdateCompaniesQueryType
): Array<SkippedCompanyType> {
    const isGalleryFieldSelected = selectedFields.some((field) => field.name === BulkEditFieldNameEnum.gallery);
    const {data} = useBatchVideoSupport(isGalleryFieldSelected ? filter : null, options);

    return data?.skipped ?? NO_SKIPPED_COMPANIES;
}
